import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// const firebaseConfig = {
//   apiKey: "AIzaSyC6GDK3P0rMLLRhJbKpbJaQMSSGUU1HuTM",
//   authDomain: "storyreels-b9953.firebaseapp.com",
//   projectId: "storyreels-b9953",
//   storageBucket: "storyreels-b9953.firebasestorage.app",
//   messagingSenderId: "475299913033",
//   appId: "1:475299913033:web:b0d4a24623ae5c8c340e98",
//   measurementId: "G-NHB0ER9CYF"
// };


// const firebaseConfig = {
//   apiKey: "AIzaSyBnPMDFu1Eaeso3duYNo9lA3zl1liu2r9w",
//   authDomain: "teacher-54ff2.firebaseapp.com",
//   databaseURL: "https://teacher-54ff2-default-rtdb.firebaseio.com",
//   projectId: "teacher-54ff2",
//   storageBucket: "teacher-54ff2.appspot.com",
//   messagingSenderId: "618731180430",
//   appId: "1:618731180430:web:c3eb424ea507c8d26e54df",
//   measurementId: "G-1RFZ707JJQ"
// };


const firebaseConfig = {
  apiKey: "AIzaSyAxNnWGtUZvpBIpkelKON36OlxJE8BKErs",
  authDomain: "myvity-85afa.firebaseapp.com",
  databaseURL: "https://myvity-85afa-default-rtdb.firebaseio.com",
  projectId: "myvity-85afa",
  storageBucket: "myvity-85afa.appspot.com",
  messagingSenderId: "986726829189",
  appId: "1:986726829189:web:8b421b98eab409e728edec",
  measurementId: "G-CP0M1PYP2E"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
export { auth };